import { format } from "date-fns";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { PublicSession, SessionInvitesStatus } from "@classview/shared-types";

import { getOrgSessionStatus } from "../utils/get-org-session-status";

import { AcceptInvitationForm } from "./accept-invitation.form";

type AcceptSessionModalProps = {
  session: PublicSession;
};

export function AcceptSessionModal({ session }: AcceptSessionModalProps) {
  const { organisation } = useOrganisation();

  const [isCreateInvitationModalOpen, setIsCreateInvitationModalOpen] =
    useState(false);
  const sessionDuration = `${format(session.start, "HH:mm")} - ${format(
    session.end,
    "HH:mm",
  )}`;

  const status = getOrgSessionStatus({
    orgId: organisation.id,
    session,
  });

  if (
    status === SessionInvitesStatus.ACCEPTED ||
    status === SessionInvitesStatus.HOST
  ) {
    return null;
  }

  return (
    <Dialog
      open={isCreateInvitationModalOpen}
      onOpenChange={setIsCreateInvitationModalOpen}
    >
      <DialogTrigger asChild>
        <Button>Accept</Button>
      </DialogTrigger>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>
            {sessionDuration} {session.name}
          </DialogTitle>
          <DialogDescription>
            Specify whom within this organisation should attend this session
          </DialogDescription>
        </DialogHeader>
        <AcceptInvitationForm
          session={session}
          onCancel={() => setIsCreateInvitationModalOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
